import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ConstraintExtended, ConstraintExtendedListResponse, ConstraintQueryParams } from '@frontend/constraint/types';

export class ConstraintExtendedClient extends APIClient {
    public static readonly endpoint = '/slot-api/ext/v1';

    public static async fetchExtendedConstraints(queryParams?: ApiQueryParams<ConstraintQueryParams>): Promise<ConstraintExtendedListResponse> {
        return await this.apiPaginated<ConstraintExtendedListResponse, ConstraintQueryParams>(`${this.endpoint}/constraints`, queryParams);
    }

    public static async fetchExtendedConstraint(accountId: string, spotId: string, constraintId: string): Promise<ConstraintExtended> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/constraints/${constraintId}`);
        return await this.handleResponse<ConstraintExtended>(response);
    }

    public static async fetchExtendedApplicableConstraints(
        accountId: string,
        spotId: string,
        queryParams?: ApiQueryParams<ConstraintQueryParams>
    ): Promise<ConstraintExtendedListResponse> {
        return await this.apiPaginated<ConstraintExtendedListResponse, ConstraintQueryParams>(
            `${this.endpoint}/accounts/${accountId}/spots/${spotId}/applicable-constraints`,
            queryParams
        );
    }
}
